export default "/images/Bid.jpg?7ee9363695c4a680fe200d105a20e159";